var rtl_rtlignore_default = {
  "rtl": "qI3pV",
  "ltr": "js2Hz"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
